import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore'
import { withLocalize, Translate } from "react-localize-redux";
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { PngFlag } from '../../common/pngFlag';
import RelationLink from '../relations/relationLink';
import OldStyleSection from '../../common/oldStyleSection';
import ExcelExportButton from '../../common/excelExportButton';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import SvgEssMultipleSubject from "../../../img/EssMultipleSubject";
import CustomTooltip from "../../common/customTooltip";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BbPopover from '../../common/popover'

import "./economicGroup.scss"
import BasicRow from '../identData/basicRow';

class EconomicGroupData extends React.Component {
    state = {
        initialized: false,
        filter: '',
        share: 25,
        lastDuplicateClickedId: null
    };

    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data));
    }

    componentDidMount() {
        if (!this.state.initialized) {
            if (this.props.data !== undefined && this.props.data !== null) {
                this.setState({ initialized: true, filter: this.props.data.filter || "EG", share: this.props.data.share || 25 });
            }
        }
    }

    renderContent = (data) => {
        const sumShare = data.owners.filter(x => x.isFinal).reduce((p, c) => p + c.share, 0);
        const finalOwners = data.owners.filter(x => x.isFinal);
        const owners = finalOwners.length > 0 ? data.owners : [this.subjectAsOwner(data), ...data.owners]
        const hasFilterInProps = !isNullOrUndefined(this.props.economicGroupSettings) && !isNullOrUndefined(this.props.economicGroupSettings.filter);
        const hasShareInProps = !isNullOrUndefined(this.props.economicGroupSettings) && !isNullOrUndefined(this.props.economicGroupSettings.share);
        const filter = data.filter;
        return (
            <div>
                <div className='ident-data-eg-columns'>
                    <div className="ident-data-eg">
                        {this.renderNameRow("Report.CompanyIdentification.CompanyName", data.companyName)}
                        <BasicRow title="Report.CompanyIdentification.Ico" value={data.companyId} className="ident-item-eg" />
                        <BasicRow title="Report.CompanyIdentification.Address" value={data.address} className="ident-item-eg" />
                        <BasicRow title="Report.CompanyIdentification.DateOfRegistration" value={data.creationDateFormated} className="ident-item-eg" />
                        <BasicRow title="Report.CompanyIdentification.PrimaryNace" value={data.nace} className="ident-item-eg" />
                    </div>
                    <div className="ident-data-eg">
                        <BasicRow title="Report.EconomicGroup.SubjectsInGroupCount" value={data.subjectsInGroupCount} className="ident-item-eg" />
                        <BasicRow title="Report.EconomicGroup.FinalOwnerCount" value={`${data.finalOwnerCount} / ${sumShare < 100 ? 'N' : data.allFinalOwnerCount}`} className="ident-item-eg" />
                    </div>
                </div>
                <br />
                {this.renderFinalOwners(finalOwners)}
                {this.renderRelations(data.relations, owners, data.maxLevel, data.negativeInfoList, filter)}
                <ExcelExportButton link="economic-group-data" entityId={this.props.id} report={this.props.reportType}
                    additionalParams={{ filter: hasFilterInProps ? this.props.economicGroupSettings.filter : this.state.filter, share: hasShareInProps ? this.props.economicGroupSettings.share : this.state.share }}
                />
            </div>
        );
    }

    renderRelations = (relations, owners, maxLevel, negInfoList, filter) => {
        return (
            <OldStyleSection name={this.props.translate("Report.EconomicGroup.EconomicGroupSectionTitle")}
                hasData={!isNullOrUndefined(relations) && relations.length > 0} isBold isOpen
            >
                <OldStyleTableWithHistory id={"essTable"} tableColumns={3} actualData={relations} stripped resolveExpanded={this.props.resolveExpanded}
                    classNames={{ "ess-table": true, "with-ellipsed-column": true, "ess-group": true }}
                    head={() => <thead className="group-data-relations-header">
                        <tr>
                            <th className="col-1"><Translate id="Report.EconomicGroup.EconomicGroupLevel" /></th>
                            <th className="col-2"><Translate id="Report.EconomicGroup.EconomicGroupNegativeInfo" /></th>
                            <th><Translate id="Report.EconomicGroup.EconomicGroupRelationType" /></th>
                        </tr>
                    </thead>}
                    actualRow={(r) => this.renderLayerRow(r, owners, maxLevel, filter)}
                />
                {this.renderNegativeInfoLegend(negInfoList)}
            </OldStyleSection>
        );
    }

    scrollToSpecificId = (id) => {
        if (!isNullOrUndefined(this.state.lastDuplicateClickedId)) {
            let oldRow = document.getElementById(this.state.lastDuplicateClickedId);
            oldRow.style.setProperty("background-color", "inherit");
            oldRow.style.setProperty("border", "");
        }

        var row = document.getElementById(id);
        row.style.setProperty("background-color", "hsla(214, 100%, 18%, .25)", "important");
        row.style.setProperty("border", "2px solid grey");

        this.setState({ lastDuplicateClickedId: id });

        row.scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        });
    }

    renderLayerRow = (row, owners, maxLevel, filter, renderShare = false) => {
        if (isNullOrUndefined(owners) || owners.length === 0)
            return null;

        const data = owners.filter(x => x.id === row.entityId);
        if (data === undefined || data === null || data.length === 0) { return null; }
        const { id, name, type, shareFormated, warnings, reports, countryId, countryName, companyId, birthDate, birthDateFormated } = data[0];
        return (

            <React.Fragment key={id}>
                <tr key={id} id={!row.duplicate && "ent_" + row.entityId} className={`colorize ${this.getRowColorClass(row.level, maxLevel)}`}>
                    {row.level === 0 && <td className='ellipsed-column'>
                        <div data-level={row.level} filter={filter} style={{ display: 'flex', flexWrap: "nowrap" }}>
                            <RelationLink entityId={id} reports={reports} entityName={name} showOnMobile={true} />
                            &nbsp;<PngFlag countryCode={countryId} title={countryName} />&nbsp;
                            {this.renderEntityIdentification(birthDate, birthDateFormated, companyId)}
                        </div>
                    </td>}
                    {row.level !== 0 && <td className='ellipsed-column'>
                        <div data-level={row.level} filter={filter} style={{ display: 'flex', flexWrap: "nowrap" }}>
                            {row.duplicate && <div onClick={() => this.scrollToSpecificId("ent_" + row.entityId)}>
                                <SvgEssMultipleSubject id={"ent_" + row.uniqueId} style={{ fill: 'orange', width: "1.5em", marginRight: '0.5em' }} />
                                <CustomTooltip textAlign="right" placement='right' id={"ent_" + row.uniqueId} text={this.props.translate("Report.Ess.Duplicate.Tooltip")} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                                </CustomTooltip></div>
                            }
                            <RelationLink entityId={id} reports={reports} entityName={name} showOnMobile={true} />
                            &nbsp;<PngFlag countryCode={countryId} title={countryName} />&nbsp;{'('}
                            {!isNullOrUndefined(birthDateFormated) ? birthDateFormated : companyId}{')'}
                        </div>
                    </td>}
                    <td data-label={this.props.translate('Report.EconomicGroup.NegativeInfo')}>
                        {warnings !== null && warnings !== undefined && warnings.length > 0 && <div style={{ display: "flex", whiteSpace: "pre-wrap" }}>
                            {warnings.map((w, i) =>
                                <div key={w.code} className={`r-padded rel-warn rel-warn-status-${w.statusId}`} title={w.description}>{w.shortening}</div>
                            )}
                        </div>}
                    </td>
                    <td data-label={this.props.translate('Report.EconomicGroup.EconomicGroupRelationType')}>
                        {renderShare && <span>{type} ({row.share}%)</span>}
                    </td>
                </tr>
                {row.childs !== null && row.childs !== undefined && row.childs.length > 0 && row.childs.map(c => this.renderLayerRow(c, owners, maxLevel, filter, true))}
            </React.Fragment>
        );
    }

    renderFinalOwners = (owners) => {
        return (
            <OldStyleSection name={this.props.translate("Report.EconomicGroup.Settings.FinalOwners")}
                hasData={!isNullOrUndefined(owners) && owners.length > 0} isBold isOpen
            >
                <OldStyleTableWithHistory tableColumns={5} actualData={owners} stripped resolveExpanded={this.props.resolveExpanded}
                    head={() => <thead>
                        <tr>
                            <th><Translate id="Report.EconomicGroup.FinalOwnerName" /></th>
                            <th style={{ width: "3.5em" }}></th>
                            <th><Translate id="Report.EconomicGroup.FinalOwnerId" /></th>
                            <th><Translate id="Report.EconomicGroup.FinalOwnerType" /></th>
                            <th><Translate id="Report.EconomicGroup.FinalOwnerShare" /></th>
                        </tr>
                    </thead>}
                    actualRow={(r) => this.renderFinalOwnerRow(r)}
                />
            </OldStyleSection>
        );
    }

    renderFinalOwnerRow = (owner) => {
        return (
            <tr key={owner.id} className='colorize'>
                <td className='ellipsed-column'>
                    <RelationLink entityId={owner.id} reports={owner.reports} entityName={owner.name} showOnMobile={true} />
                </td>
                <td><PngFlag countryCode={owner.countryId} title={owner.countryName} /> </td>
                <td>{owner.birthDateFormated !== null && owner.birthDateFormated !== undefined ? owner.birthDateFormated : owner.companyId}</td>
                <td>{owner.type}</td>
                <td>{owner.shareFormated}{!isNullOrUndefined(owner.share) ? " %" : ""}</td>
            </tr>
        );
    }

    renderFinalBenefitsUsers = (users) => {
        if (isNullOrUndefined(users))
            users = [];

        return (
            <OldStyleSection name={this.props.translate("Report.EconomicGroup.Settings.FinalBenefitsUsers")}
                hasData={!isNullOrUndefined(users) && users.length > 0} isBold isOpen
            >
                <OldStyleTableWithHistory tableColumns={5} actualData={users} stripped resolveExpanded={this.props.resolveExpanded}
                    head={() => <thead>
                        <tr>
                            <th style={{ width: "3.5em" }}></th>
                            <th style={{ width: "30%" }}><Translate id="Report.EconomicGroup.FinalBenefitsUser.Name" /></th>
                            <th style={{ width: "20%" }}><Translate id="Report.EconomicGroup.FinalBenefitsUser.Relation" /></th>
                            <th><Translate id="Report.EconomicGroup.FinalBenefitsUser.Address" /></th>
                            <th style={{ width: "10%" }}><Translate id="Report.Common.Source" /></th>
                            <th style={{ width: "3em", fontSize: "1.15em" }}>
                                <BbPopover title={this.props.translate("Report.ESS.Owner.Tooltip.Header")} content={this.props.translate("Report.ESS.Owner.Tooltip")} placement="left" targetId="ESS-owner-tooltip-popover">
                                    <span href="#" className="icon-gray print-hidden" id="ESS-owner-tooltip-popover" style={{ cursor: "pointer" }}><FontAwesomeIcon icon="question-circle" /></span>
                                </BbPopover>
                            </th>

                        </tr>
                    </thead>}
                    actualRow={(r) => <tr key={r.id} className="colorize">
                        <td className="flag"><PngFlag countryCode={r.countryCode} title={r.countryName} /></td>
                        <td>{r.name}</td>
                        <td>{isNullOrUndefined(r.function) ? r.relationName : r.relationName + " - " + r.function}</td>
                        <td>{r.address}</td>
                        <td title={r.sourceDescription}>{r.sourceShortening}</td>
                    </tr>}
                />
            </OldStyleSection>
        );
    }

    renderNameRow = (title, text) => {
        if (isNullOrUndefined(text))
            return null;

        return (
            <div className="ident-item-eg">
                <span><Translate id={title} /></span>
                <span className="bold-name">{text}</span>
            </div>
        );
    }

    renderEntityIdentification = (birthDate, birthDateFormated, companyId) => {
        if (isNullOrUndefined(birthDateFormated) && (isNullOrUndefined(companyId) || companyId.length === 0))
            return null;

        return <>({!isNullOrUndefined(birthDateFormated) ? birthDateFormated : companyId})</>
    }

    renderNegativeInfoLegend = (ni) => {
        if (isNullOrUndefined(ni) || ni.length === 0)
            return null;

        return (
            <>
                <hr />
                <OldStyleSection name={this.props.translate("Report.EconomicGroup.Legend.NI")} hasData isBold>
                    <OldStyleTableWithHistory tableColumns={3} actualData={ni} stripped resolveExpanded={this.props.resolveExpanded}
                        head={() => <thead>
                            <tr>
                                <th><Translate id="Report.EconomicGroup.Legend.NI.Shortening" /></th>
                                <th><Translate id="Report.EconomicGroup.Legend.NI.Description" /></th>
                                <th><Translate id="Report.EconomicGroup.Legend.NI.Source" /></th>
                            </tr>
                        </thead>}
                        actualRow={(r) => <tr key={r.id} className="colorize">
                            <td>{r.shortening}</td>
                            <td>{r.description}</td>
                            <td>{r.source}</td>
                        </tr>}
                    />
                </OldStyleSection>
            </>
        );
    }

    getRowColorClass = (level, maxLevel) => {
        let color = 19;

        if (maxLevel > 19)
            maxLevel = 19;

        if (level > 19)
            level = 19;

        if (level > maxLevel)
            level = maxLevel;

        if (maxLevel < 5)
            color = 10 + Math.floor(10 / maxLevel) * level;
        else if (maxLevel >= 5 && maxLevel < 10)
            color = 1 + Math.floor(20 / maxLevel) * level;
        else
            color = (20 - maxLevel) + level;

        return `color-${color}`;
    }

    subjectAsOwner = (s) => {
        return {
            birthDate: null,
            birthDateFormated: null,
            companyId: s.ico,
            countryId: s.countryCode,
            countryName: s.countryName,
            id: s.id,
            isFinal: false,
            name: s.companyName,
            reports: s.reports,
            share: null,
            shareFormated: "",
            type: "",
            warnings: s.warnings
        }
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(EconomicGroupData));
